import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { IUser as IGeoUser, LoginStatusService } from "@geolib/geoappbase-client";
import { Observable, of } from "rxjs";
import { map } from "rxjs/operators";
import { RoleName } from "../user/IRole";
import IUser from "../user/IUser";
import { IdentityService } from "./IdentityService";


@Injectable({
    providedIn: "root",
})
export class AuthenticationService {

    private lastAuthorized = 0;

    public constructor(
        private readonly http: HttpClient,
        private readonly identityService: IdentityService,
        private readonly loginStatusService: LoginStatusService,
    ) {
        this.checkInitialLoginState();
    }

    private checkInitialLoginState(): void {
        this.getUser();
    }

    public wasPreviouslyAuthorized(): boolean {
        return (Date.now() - this.lastAuthorized < 60 * 1000);
    }

    public authenticateUser(username: string, password: string, rememberme: boolean): Observable<{ success: boolean; user: IUser; reason?: string }> {
        return this.http.post("/api/login", { username, password, logintype: "local", rememberme }).pipe(
            map((data: IUser) => {
                if (data) {
                    this.identityService.currentUser = data;
                    this.loginStatusService.setCurrentUser(data as unknown as IGeoUser);
                    return { success: true, user: data };
                } else {
                    throw new Error("login failed");
                }
            }));
    }

    public getUser(): Observable<{ success: boolean; user: IUser; reason?: string }> {
        if (!this.wasPreviouslyAuthorized() && this.identityService.currentUser) {
            return of({ success: true, user: this.identityService.currentUser });
        }

        return this.http.get("/api/login").pipe(
            map((data: IUser) => {
                if (data) {
                    this.identityService.currentUser = data;
                    return { success: true, user: data };
                } else {
                    throw new Error("login failed");
                }
            }));
    }

    public authorizeCurrentUserForRoute(roles: RoleName[]): Promise<boolean> {
        if (this.identityService.isAuthorized(...roles)) {
            return Promise.resolve(true);
        } else {
            return Promise.reject("not authorized");
        }
    }

}
